"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textarea = void 0;

var _color = _interopRequireDefault(require("../choices/color.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _timing = _interopRequireDefault(require("../choices/timing.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var textarea = {
  textareaFontFamily: _font["default"].family,
  textareaFontSize: _font["default"].sizeSm,
  textareaFontStyle: 'normal',
  textareaFontWeight: _font["default"].weightDefault,
  textareaLetterSpacing: 'normal',
  textareaLineHeight: _font["default"].lineHeightSm,
  textareaWidth: '100%',
  textareaColor: _color["default"].pickledBluewood800,
  textareaColorReadOnly: _color["default"].steel700,
  textareaColorDisabled: _color["default"].cloudyBlue,
  textareaPlaceholderColor: _color["default"].cloudyBlue,
  textareaBackgroundColor: _color["default"].white,
  textareaBackgroundColorDisabled: _color["default"].cloudyBlue100,
  textareaBorderColor: _color["default"].cloudyBlue300,
  textareaBorderColorReadOnly: _color["default"].cloudyBlue300,
  textareaBorderColorDisabled: _color["default"].cloudyBlue300,
  textareaBorderColorFocus: _color["default"].dodgerBlue,
  textareaBorderColorError: _color["default"].coral,
  textareaBorderRadius: 0,
  textareaPadding: _spacing["default"].xs,
  textareaTransitionTiming: _timing["default"].fast
};
exports.textarea = textarea;
var _default = textarea;
exports["default"] = _default;